import { createColumnHelper } from '@tanstack/vue-table';
import { h } from 'vue'
import BasicStatus from '@/components/DataTable/BasicStatus';

const columnHelper = createColumnHelper();


function createColumn(accessor, header, size, cell = ({ getValue }) => getValue()) {
  return columnHelper.accessor(accessor, {
    header,
    cell,
    size,
  });
}

export function getTemplateDownloadHistoryColumns() {
  return [
    createColumn('dealFile', 'Şablon', 709),
    createColumn('docCreatedDate', 'Oluşturma Tarihi', 176),
    createColumn(
      'status',
      'Durum',
      176,
      ({ getValue }) =>
        h(BasicStatus, {
          type: getValue(),
        }),
    ),
    createColumn('process', 'İşlem', 115),
  ];
}

export function getFileUploadHistoryTableColumn() {
  return [
    createColumn('dealFile', 'Dosya', 300),
    createColumn('docCreatedDate', 'Yüklenme Tarihi', 176),
    createColumn('dealCount', 'Yüklenen Teklif', 176),
    createColumn('succeededDealCount', 'Başarılı Güncellenen Teklif', 176),
    createColumn(
      'status',
      'Durum',
      176,
      ({ getValue }) =>
        h(BasicStatus, {
          type: getValue(),
        }),
    ),
    createColumn('failedDealCount', 'Hatalı Ürün', 106),
  ];
}